import { AnimatePresence, motion } from "framer-motion"
import type { CSSProperties } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";

const MotionLink = motion.create(Link)
const tapHighlightStyle: CSSProperties = {
    WebkitTapHighlightColor: "transparent",
}

const DEFAULT_SHOWCASE_ROUTER_NAME = "/showcase/"
const DODU_SHOWCASE_ROUTER = [
    {
        name: "DODU-Theme",
        path: "/showcase/theme/dodu",
        key: "dodu-theme"
    },
    {
        name: "DODU-Watch",
        path: "/showcase/watch/dodu",
        key: "dodu-watch"
    },
]

const pageVariants = {
    initial: { opacity: 0, x: 24 },
    animate: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: -24 },
}

const pageTransition = {
    duration: 0.3,
    ease: "easeInOut",
}

const ShowCaseLayout = () => {
    const location = useLocation()
    const isRoot = location.pathname === DEFAULT_SHOWCASE_ROUTER_NAME

    return (
        <main className="w-full flex flex-col overflow-hidden overscroll-none" style={{ height: '100dvh' }}>
            <nav className="bg-white shrink-0 h-[11%] text-xl md:h-[8%] font-semibold flex items-center justify-evenly gap-1 border border-b-[#e2e5e4]">
                {DODU_SHOWCASE_ROUTER.map((router) => (
                    <MotionLink
                        key={router.key}
                        to={router.path}
                        className={`${location.pathname === router.path ? "border-2 border-[#2f6c5c] bg-[#2f6c5c] font-bold" : "text-[#92a093]"} 
                                  select-none rounded-full px-4 py-2 text-white font-medium outline-none focus-visible:ring-2 focus-visible:ring-[#2f6c5c]/40 md:text-xl`}
                        style={tapHighlightStyle}
                        whileHover={{ y: -2, scale: 1.04 }}
                        whileTap={{ scale: 0.95 }}
                        transition={{ duration: 0.18, ease: "easeOut" }}
                    >
                        {router.name}
                    </MotionLink>
                ))}
            </nav>
            <div className="flex-1 min-h-0 overflow-hidden overscroll-none">
                <AnimatePresence mode="wait">
                    <motion.div
                        key={location.pathname}
                        variants={pageVariants}
                        initial="initial"
                        animate="animate"
                        exit="exit"
                        transition={pageTransition}
                        className="h-full"
                    >
                        {isRoot ? (
                            <div>
                                <h1 className="text-white">ShowCase</h1>
                            </div>
                        ) : (
                            <Outlet />
                        )}
                    </motion.div>
                </AnimatePresence>
            </div>
        </main>
    )
}

export default ShowCaseLayout
